import React from 'react';
import styled from 'styled-components';
import NavigationTabs from '../NavigationTabs/NavigationTabs';
import { Body } from '../../typography';
import Button from '../../atoms/Button';
import { colors, fontSizes } from '../../../defaultTheme';
import query from '../../../const/mediaQueries';
import DropdownMenu from '../DropdownMenu';
export const HeaderWrapper = styled.div `
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;
  height: 100%;
  max-width: 1200px;

  @media ${query.greaterThanLarge} {
    padding: 0 40px;
  }
`;
export const AccountHeaderWrapper = styled.div `
  display: flex;
  width: 100%;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.lightGrey};
  box-sizing: border-box;
  flex-direction: column;

  @media (min-width: ${({ breakpoint }) => `${breakpoint}px`}) {
    align-items: center;
    padding: 0 40px;
  }
`;
export const DrawerHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
`;
export const PageNavigation = styled(NavigationTabs) `
  display: none;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin-top: 0;
  margin-bottom: 0;
  height: 56px;

  @media (min-width: ${({ breakpoint }) => `${breakpoint}px`}) {
    display: flex;
  }
`;
export const ContentWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export const Title = styled(Body) `
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${query.greaterThanSmall} {
    font-size: ${fontSizes.medium}px;
  }

  @media ${query.greaterThanMedium} {
    max-width: none;
  }
`;
export const LogoImage = styled.img `
  margin-right: 16px;
  width: 56px;
  height: 36px;
  padding: 5px;
  object-fit: contain;
  border-radius: 3px;

  @media (min-width: ${({ breakpoint }) => `${breakpoint}px`}) {
    padding: 0px;
  }
`;
export const HamburgerButton = styled(Button) `
  display: block;
  width: 24px;
  margin: 8px;
  padding: 0px;
  outline: none;

  @media (min-width: ${({ breakpoint }) => `${breakpoint}px`}) {
    display: none;
  }
`;
export const CreditCardIconWrapper = styled.div `
  font-size: ${fontSizes.root}px;
  margin: 0 8px;
  display: none;

  @media (min-width: ${({ breakpoint }) => `${breakpoint}px`}) {
    display: block;
  }
`;
export const IconFrame = styled.span `
  font-size: ${fontSizes.root}px;
`;
export const SwitchAccountDropdownMenu = styled(DropdownMenu) `
  ul {
    left: auto;
    right: 32px;
    width: 480px;
    border-radius: 10px;

    @media ${query.lessThanMedium} {
      right: 0;
      width: 100%;
    }
  }
`;
export const SwitchAccountButton = styled(Button) `
  margin: 4px;
  min-width: auto;
`;
export const SwitchAccountButtonLabel = styled(Body) `
  display: none;
  padding-right: 8px;

  @media (min-width: ${({ breakpoint }) => `${breakpoint}px`}) {
    display: block;
  }
`;
export const SwitchDropdownTrigger = ({ children, toggleMenu, dataType, dataReason, ariaLabel = 'Switch Account' }) => {
    return (React.createElement(SwitchAccountButton, { "data-type": dataType, "data-reason": dataReason, className: "ensightencustomevent", buttonType: "ghost", onClick: toggleMenu, ariaLabel: ariaLabel }, children));
};
